import { ICandidateViewModel } from '@/public/vote/models/candidate-view-model';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import _ from 'lodash';
import { VueAutosuggest } from 'vue-autosuggest';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        VueAutosuggest,
        GenderIconComponent
    }
})
export default class CandidateSearchComponent extends Vue {

    @Prop() public candidates!: ICandidateViewModel[];
    @Prop() public showGenders!: boolean;
    @Prop() public translations!: { [key: string]: string; };

    public searchResult: ICandidateViewModel[] = [];

    public query!: string;

    public suggestions: any[] = [];

    /**
     *
     */
    constructor() {
        super();

        this.query = '';
    }

    @Emit()
    public selected(item: ICandidateViewModel): ICandidateViewModel {

        this.reset();

        return item;
    }

    public selectHandler(suggestion: any): void {

        if (!suggestion || !suggestion.item || !suggestion.item.object) {
            return;
        }

        if (suggestion.item.object.disabledByNoSelfVoting) {
            return;
        }

        this.selected(suggestion.item);
    }

    public clickHandler(suggestion: any): void {

        if (!suggestion || !suggestion.item || !suggestion.item.object) {
            return;
        }

        if (suggestion.item.object.disabledByNoSelfVoting) {
            return;
        }

        this.selected(suggestion.item);
    }

    public onInputChange(text: string): void {

        if (text === '' || text === undefined) {

            this.suggestions = [];
            return;
        }

        const filteredData = this.candidates.filter(item => {

            return item.object.displayName.toLowerCase().indexOf(text.toLowerCase()) > -1;
        }).slice(0, 10);

        this.suggestions = [
            {
                data: filteredData
            }
        ];
    }

    public getSuggestionValue(suggestion: any) {

        return suggestion.item.displayName;
    }

    private reset(): void {

        this.query = '';

        this.suggestions = [];
    }
}
